import React, { useState } from 'react'
import SimpleReactValidator from 'simple-react-validator'

const useValidator = (customMessage = {}, customValidator = {}) => {
  const [show, setShow] = useState(false)
  const validator = new SimpleReactValidator({
    element: (message, className) => <div className="text-danger">{message}</div>,
    messages: customMessage, 
    validators: customValidator
  }) 

  if (show) {
    validator.showMessages()
  }

  return [validator, setShow]
}

export default useValidator;